import { useContext, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import styles from "./ContactForm.module.css";
import { ContactUs2Context } from "../../store/ContactUs2Context";
import downloadIcon from "../../assets/ContactFormUploadPng.png";
import { LanguageContext } from "../LanguageContext/LanguageContext";
import { MdDelete } from "react-icons/md";
// import { useNavigate } from "react-router-dom";

const RequiredAsteriskIcon = () => (
  <svg xmlns="https://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.49489 7C5.42742 7 7 5.43707 7 3.50383C7 1.57059 5.42487 0 3.49489 0C1.56492 0 0 1.57315 0 3.50383C0 5.43451 1.56236 7 3.49489 7ZM0.857768 3.35826L1.22794 2.22437C2.07039 2.52317 2.68308 2.77855 3.06601 2.99818C2.96645 2.03028 2.91284 1.37395 2.90518 1.01386H4.06929C4.05398 1.53484 3.99271 2.19373 3.88549 2.99051C4.43691 2.71215 5.06492 2.45677 5.77206 2.22437L6.13968 3.35826C5.46572 3.583 4.79942 3.72601 4.14843 3.80263C4.47775 4.0861 4.93217 4.59175 5.52188 5.31448L4.57221 5.9938C4.25821 5.57242 3.8957 5.00037 3.47702 4.28019C3.07877 5.02846 2.73414 5.60306 2.4329 5.9938L1.49088 5.31448C2.10357 4.55345 2.55033 4.04779 2.81583 3.80263C2.12655 3.67494 1.47557 3.51915 0.860321 3.35826H0.857768Z" fill="#5AFFFF"/>
  </svg>
);
const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;
const ContactForm = () => {
  const { contactUs2ContextDetails, loading, error } = useContext(ContactUs2Context);
  const { language } = useContext(LanguageContext);
  // const navigate  = useNavigate()
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading data</p>;

  const contactDetailsSec3 = contactUs2ContextDetails?.contactDetails2Sec3 || [];
  const title = contactDetailsSec3[0]?.title || "";
  const fullNameTitle = contactDetailsSec3[1]?.title || "Full Name";
  const emailTitle = contactDetailsSec3[2]?.title || "Email";
  const emailPlaceholder = contactDetailsSec3[2]?.description || "adi.abed@gmail.com";
  const phoneTitle = contactDetailsSec3[3]?.title || "Phone Number";
  const phonePlaceholder = contactDetailsSec3[3]?.description || "966-354-2011";
  const jobRoleTitle = contactDetailsSec3[4]?.title || "I Would Like to Join the world of Maflam as:";
  const jobRoleCategories = contactDetailsSec3[4]?.category || [];
  const currentJobTitle = contactDetailsSec3[5]?.title || "Current Job Title";
  const experienceTitle = contactDetailsSec3[6]?.title || "Years of experience";
  const experienceCategories = contactDetailsSec3[6]?.category || [];
  const coverLetterTitle = contactDetailsSec3[7]?.title || "Cover Letter";
  const coverLetterPlaceholder = contactDetailsSec3[7]?.description || "Write...";
  const resumeTitle = contactDetailsSec3[8]?.title || "Resume";
  const portfolioTitle = contactDetailsSec3[9]?.title || "Portfolio";
  const submitButtonTitle = contactDetailsSec3[10]?.title || "Send";

  const [resume, setResume] = useState(null);
  const [portfolio, setPortfolio] = useState(null);
  const [selectedJobRole, setSelectedJobRole] = useState(null);
  const [selectedExperience, setSelectedExperience] = useState(null);
  const [formData, setFormData] = useState({
    fullNameInEng: "",
    email: "",
    phoneNo: "",
    jobTitleInEng: "",
    coverLetterInEng: "",
    maflamWorldAsInEng: "",
    experienceInEng: "",
  });
 

  const handleFileUpload = (e, setter) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file size (2MB limit)
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      if (file.size > maxSize) {
        alert(language === "en"
          ? "File size should be less than 2MB"
          : "يجب أن يكون حجم الملف أقل من 2 ميجابايت"
        );
        e.target.value = ''; // Reset input
        return;
      }

      // Validate file type
      const allowedTypes = ['.pdf'];
      const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
      if (!allowedTypes.includes(fileExtension)) {
        alert(language === "en"
          ? "Please upload PDF file only"
          : "يرجى تحميل ملف PDF فقط"
        );
        e.target.value = ''; // Reset input
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setter({
          name: file.name,
          base64: base64String
        });
      };
      reader.onerror = () => {
        alert(language === "en"
          ? "Error reading file"
          : "خطأ في قراءة الملف"
        );
        e.target.value = ''; // Reset input
      };
      reader.readAsDataURL(file);
    }
  };
  

  const handleDeleteFile = (setter) => {
    setter(null);
    // Reset the file input
    if (setter === setResume) {
      document.getElementById('resumeUpload').value = '';
    } else if (setter === setPortfolio) {
      document.getElementById('portfolioUpload').value = '';
    }
  };

  const handlePhoneInput = (e) => {
    e.target.value = e.target.value.replace(/\D/g, "");
  };

  const handleSelect = (index, setter, fieldName) => {
    setter((prev) => {
      const newValue = prev === index ? null : index;
      
      // Update formData based on selection type
      if (fieldName === 'jobRole') {
        setFormData(prev => ({
          ...prev,
          maflamWorldAsInEng: newValue !== null ? jobRoleCategories[newValue] : ""
        }));
      } else if (fieldName === 'experience') {
        setFormData(prev => ({
          ...prev,
          experienceInEng: newValue !== null ? experienceCategories[newValue] : ""
        }));
      }
      
      return newValue;
    });
  };

  const triggerFileUpload = (id) => {
    document.getElementById(id).click();
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 1000, behavior: "smooth" });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const toastConfig = {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      style: {
        background: 'black',
        color: 'rgb(57, 255, 251)',
        marginTop: "15px",
        minHeight: "64px",
        zIndex: 9999
      }
    };

    try {
      // Validate form
      if (!formData.maflamWorldAsInEng) {
        toast.error(
          language === "en" 
            ? "Please select your role in Maflam world" 
            : "يرجى تحديد دورك في عالم مفلام",
          toastConfig
        );
        return;
      }

      if (!formData.experienceInEng) {
        toast.error(
          language === "en" 
            ? "Please select your years of experience" 
            : "يرجى تحديد سنوات خبرتك",
          toastConfig
        );
        return;
      }

      // Create payload with only base64 strings for files
      const payload = {
        ...formData,
        resume: resume?.base64 || '', // Send only the base64 string
        portfolio: portfolio?.base64 || '' // Send only the base64 string
      };

      const response = await axios.post(
        `${marketingBackendUrl}/maflam/create-job-form`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      toast.success(
        language === "en" 
          ? "Form submitted successfully" 
          : "تم إرسال النموذج بنجاح",
        toastConfig
      );

      // Reset form after successful submission
      setTimeout(() => {
        setFormData({
          fullNameInEng: "",
          email: "",
          phoneNo: "",
          jobTitleInEng: "",
          coverLetterInEng: "",
          maflamWorldAsInEng: "",
          experienceInEng: "",
        });
        setResume(null);
        setPortfolio(null);
        setSelectedJobRole(null);
        setSelectedExperience(null);
      }, 1000);

    } catch (error) {
      console.error('Error submitting job form:', error);
      toast.error(
        language === "en" 
          ? "Error submitting form" 
          : "حدث خطأ أثناء إرسال النموذج",
        toastConfig
      );
    }
  };

  const btnText = language === "en" ? "Upload file" : "تحميل الملف";

  return (
    <div className={styles.container}>
      <div className={styles.formContainer}>
        <div className={styles.formcontact}>
        <h2 className={styles.title}>{title}</h2>
        <div style={{width:'100%', overflow:'hidden', display:'flex', justifyContent:'center'}}>
          <svg
            xmlns="https://www.w3.org/2000/svg"
            width="963"
            height="3"
            viewBox="0 0 963 3"
            fill="none"
          >
            <path
              opacity="0.1"
              d="M1 2L962 1.00008"
              stroke="#F1F2FA"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
          </div>
        <form className={styles.contactForm} onSubmit={handleSubmit}>
          <div className={styles.inputGroup}>
            <label htmlFor="fullNameInEng">
              {fullNameTitle} <span style={{position:'relative', top:'-12px'}}>< RequiredAsteriskIcon/></span>
            </label>
            <input 
              style={{backgroundColor:'rgb(26, 55, 75)'}}
              autoFocus
              type="text"
              required
              id="fullNameInEng"
              maxLength={50}
              placeholder="Full Name"
              value={formData.fullNameInEng}
              onChange={handleInputChange}
            />
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="email">
              {emailTitle} <span style={{position:'relative', top:'-12px'}}>< RequiredAsteriskIcon/></span>
            </label>
            <input 
            style={{backgroundColor:'rgb(26, 55, 75)'}}
              type="email"
              id="email"
              required
              placeholder={emailPlaceholder}
              value={formData.email}
              onChange={handleInputChange}
            />
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="phoneNo">
              {phoneTitle} <span style={{position:'relative', top:'-12px'}}>< RequiredAsteriskIcon/></span>
            </label>
            <input
            style={{backgroundColor:'rgb(26, 55, 75)'}}
              type="text"
              id="phoneNo"
              required
              maxLength={16}
              placeholder={phonePlaceholder}
              onInput={handlePhoneInput}
              value={formData.phoneNo}
              onChange={handleInputChange}
            />
          </div>

          <div className={styles.inputGroup}>
            <label>{jobRoleTitle} <span style={{position:'relative', top:'-12px'}}>< RequiredAsteriskIcon/></span></label>
            <div className={styles.radioGroup}>
              {jobRoleCategories.map((role, index) => (
                <button
                  key={index}
                  type="button"
                  required
                  className={`${styles.radioButton} ${selectedJobRole === index ? styles.selected : ""}`}
                  onClick={() => handleSelect(index, setSelectedJobRole, 'jobRole')}
                >
                  {role}
                </button>
              ))}
            </div>
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="jobTitleInEng">
              {currentJobTitle} <span style={{position:'relative', top:'-12px'}}>< RequiredAsteriskIcon/></span>
            </label>
            <input
            style={{backgroundColor:'rgb(26, 55, 75)'}}
              type="text"
              id="jobTitleInEng"
              required
              maxLength={60}
              placeholder="Answer"
              value={formData.jobTitleInEng}
              onChange={handleInputChange}
            />
          </div>

          <div className={styles.inputGroup}>
            <label>{experienceTitle}</label>
            <div className={styles.radioGroup}>
              {experienceCategories.map((exp, index) => (
                <button
                  key={index}
                  type="button"
                  className={`${styles.radioButton} ${selectedExperience === index ? styles.selected : ""}`}
                  onClick={() => handleSelect(index, setSelectedExperience, 'experience')}
                >
                  {exp}
                </button>
              ))}
            </div>
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="coverLetterInEng">
              {coverLetterTitle} <span style={{position:'relative', top:'-12px'}}>< RequiredAsteriskIcon/></span>
            </label>
            <textarea
              style={{backgroundColor:'rgb(26, 55, 75)'}}
              id="coverLetterInEng"
              required
              placeholder={coverLetterPlaceholder}
              value={formData.coverLetterInEng}
              onChange={handleInputChange}
            />
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="resumeUpload">
              {resumeTitle} 
              <span style={{position:'relative', top:'-12px'}}>< RequiredAsteriskIcon/></span>
            </label>
            <div className={styles.imgUpload}>
              {resume ? (
                <>
                  <span title={resume.name}>{resume.name}</span> 
                  <button 
                    type="button" 
                    onClick={() => handleDeleteFile(setResume)} 
                    className={styles.deleteButtons}
                  >
                    <i><MdDelete /></i>
                  </button>
                </>
              ) : (
                <div className={styles.btnstyless}>
                  <button
                    style={{width:'50px'}}
                    type="button"
                    onClick={() => triggerFileUpload("resumeUpload")}
                    className={styles.downloadIcon}
                  >
                    <img style={{position:'relative'}} src={downloadIcon} alt="Upload Resume" />
                  </button>
                  <p className="uploadFile">{btnText}</p>
                </div>
              )}
              <input
                type="file"
                id="resumeUpload"
                style={{ display: "none" }}
                onChange={(e) => handleFileUpload(e, setResume)}
                accept=".pdf"
              />
            </div>
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="portfolioUpload">{portfolioTitle}</label>
            <div className={styles.imgUpload}>
              {portfolio ? (
                <>
                  <span title={portfolio.name}>{portfolio.name}</span>
                  <button 
                    type="button" 
                    onClick={() => handleDeleteFile(setPortfolio)} 
                    className={styles.deleteButtons}
                  >
                    <i><MdDelete /></i>
                  </button>
                </>
              ) : (
                <div className={styles.btnstyless}>
                  <button
                    style={{width:'50px'}}
                    type="button"
                    onClick={() => triggerFileUpload("portfolioUpload")}
                    className={styles.downloadIcon}
                  >
                    <img style={{position:'relative'}} src={downloadIcon} alt="Upload Portfolio" />
                  </button>
                  <p className="uploadFile">{btnText}</p>
                </div>
              )}
              <input
                type="file"
                id="portfolioUpload"
                style={{ display: "none" }}
                onChange={(e) => handleFileUpload(e, setPortfolio)}
                accept=".pdf"
              />
            </div>
          </div>

          <button type="submit" className={styles.submitButton}>
            {submitButtonTitle}
          </button>
        </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;


